'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconMessage, iconMessageTag } from '@ni/nimble-components/dist/esm/icons/message';
import { wrap } from '../../utilities/react-wrapper';

export type { IconMessage };
export { iconMessageTag };
export const NimbleIconMessage = wrap(IconMessage);